const actions = {

    async AJAX_SEND({rootState}, body) {
        try {

            var params = {
                route  :  body.route,
                method :  body.method,
            }
            if (body.token !== 'public') {
                params.headers = {'Authorization': `Bearer ${body.token}`}
            }

            if (body.data) {
                params['body'] = body.data
            }

            const data = await rootState.$ajax(params);
            if (data.result) {
                return data
            } else {
                console.log(data)
                return data
            }

        } catch (e) {
            console.log(e)
            return e.error
        }
    },

    async LINK_BUSINESS({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'liqpay/link',
                method:'PUT',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },
    async UNLINK_BUSINESS({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'liqpay/unlink',
                method:'DELETE',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },
    async GET_BUSINESS_BUTTON({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'liqpay/button/business',
                method:'POST',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );

    },


    // old
    async CHECKOUT_AUTH({rootState,dispatch},body) {
        return await dispatch('AJAX_SEND',{token:rootState.auth.accessToken, route:`liqpay/auth/checkout`, method:'POST', data:body} );
    },




}

export default {
    namespaced:true,
    actions,
}